// extracted by mini-css-extract-plugin
module.exports = {"content":"Product_content__1ONWZ","submitBtn":"Product_submitBtn__3orej","checkbox":"Product_checkbox__2RA3C"};